exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color1[data-v-5f5af1e1]{color:#ff9900}.color2[data-v-5f5af1e1]{color:#19be6b}.color3[data-v-5f5af1e1]{color:#ed4014}[data-v-5f5af1e1] .el-input__inner{text-align:left}.from-item-title[data-v-5f5af1e1]{border-left:5px solid #1890ff}.from-item-title span[data-v-5f5af1e1]{padding-left:10px;font-weight:bold;font-size:14px}[data-v-5f5af1e1] .el-tag{background-color:transparent}\n", ""]);

// exports
